var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setting-google-analytics"},[_c('edit',{attrs:{"fs":_vm.googleAnalyticsFields,"api":"settings","id":"google-analytics","title":"Google Analytics Setting"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }